import moment from 'moment';
import React, { FC, useState } from 'react';
import { TdsItem, Env, Version } from '../enum/tds';
import {
  NAVIGATION_URL,
} from '../tds-navigation/config';
import {
  TDS_PLATFORM_LIST,
  DEFAULT_ICP,
  DEFAULT_ICP_URL,
} from './config';
import TdsActiveLogo from './image/tds-active.svg';
import TdsLogo from './image/tds.svg';
import './index.scss';

interface FooterProps {
  privacyPolicyUrl?: string;
  // 备案号
  icp?: string;
  icpURL?: string;
  isProd?: boolean;
  isWoa?: boolean;
}

export const TdsFooter: FC<FooterProps> = (props) => {
  const {
    icp = DEFAULT_ICP,
    icpURL = DEFAULT_ICP_URL,
    isProd = true,
    isWoa = false,
    privacyPolicyUrl,
  } = props;
  const [active, setActive] = useState(false);
  const version = isWoa ? Version.WOA : Version.PRO;
  const env = isProd ? Env.PROD : Env.TEST;
  const homeUrl = NAVIGATION_URL[TdsItem.Home][version][env];

  const icpOnClick = () => {
    if (!icpURL) {
      return;
    }
    const a = document.createElement('a');
    a.href = icpURL;
    a.target = '_blank';
    a.click();
  };


  const handleOpenUrl = (src: string) => {
    if (src) {
      window.open(src, '_self');
    }
  };

  return <div className={'tds-footer'}>
    <div className='product-row'>
      <img
        src={active ? TdsActiveLogo : TdsLogo}
        alt=""
        className='tds-footer-logo'
        onClick={() => handleOpenUrl(homeUrl)}
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      />
      {TDS_PLATFORM_LIST.map((product, idx) => (
        <div key={idx} className='btn-text' onClick={() => {
          const url = `${NAVIGATION_URL[product.key][version][env]}${product.key === TdsItem.Home ? '?isMore=true' : ''}`;
          if (window.location.href.includes(homeUrl)) {
            handleOpenUrl(url);
          } else {
            window.open(url);
          }
        }}>
          {product.title}
        </div>
      ))}
    </div>
    <div className='flex-layout' style={{ gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
      <span>Copyright © 1998 - {moment().year()} Tencent. All Rights Reserved.</span>
      <div className='flex-layout' style={{ gap: '10px' }}>
        <div className='privacy-row footer-pcg-href'>
          <a className='footer-pcg-href-link' href='https://www.qq.com/contract.shtml' target='_blank'>服务协议</a>
          <div className='divider-vertical' />
          <a className='footer-pcg-href-link' href={privacyPolicyUrl || 'https://privacy.qq.com/policy/tencent-privacypolicy'} target='_blank'>隐私保护声明</a>
        </div>
        <div className='privacy-row footer-pcg-href'>
          腾讯公司
          <div className='divider-vertical' />
          版权所有
          <div className='divider-vertical' />
          <a className='footer-pcg-href-link' onClick={icpOnClick}>主体备案号 {icp}</a>
        </div>
      </div>
    </div>
  </div>;
};
